import { SortByFn } from 'react-table';
import { compareDesc, compareAsc } from 'date-fns';

export const sortDate: SortByFn<{}> = (rowA, rowB, columnId, desc) => {
  const dateA = new Date(rowA.values[columnId]);
  const dateB = new Date(rowB.values[columnId]);
  return desc ? compareDesc(dateB, dateA) : compareAsc(dateA, dateB);
};
